import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "w-screen h-screen flex items-center justify-center",
  style: {"background":"rgba(0, 0, 0, 0.2)","z-index":"1049","position":"fixed","top":"0"}
}
const _hoisted_2 = { class: "container-img-advertise" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "img-bg object-contain",
  style: {"border-radius":"24px"}
}, null, -1)
const _hoisted_4 = { class: "container-timer" }
const _hoisted_5 = {
  key: 1,
  class: "text-white font-semibold mx-2 my-1",
  style: {"font-size":"0.875rem"}
}
const _hoisted_6 = /*#__PURE__*/_createVNode("small", null, "s", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "load-transition",
    "enter-active-class": "animate__animated animate__fast animate__fadeIn",
    "leave-active-class": "animate__animated animate__fadeOut animate__faster"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            ($setup.countDown === 0)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "pi pi-times text-white cursor-pointer m-2",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.hide()))
                }))
              : (_openBlock(), _createBlock("p", _hoisted_5, [
                  _createTextVNode(_toDisplayString($setup.countDown), 1),
                  _hoisted_6
                ]))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}